/**
 * ring-buffer.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

export class RingBuffer<T> implements Iterable<T>
{
  private buffer : T[];
  private start : number = 0;
  private end : number = 0;
  private empty : boolean = true;

  constructor (private readonly max : number)
  {
    this.buffer = new Array(max);
  }

  public add (entry : T) : void
  {
    this.buffer[this.end] = entry;
    if (this.empty)
    {
      // no longer empty
      this.empty = false;
    }
    else if (this.start === this.end)
    {
      this.start = (this.start + 1) % this.max;
    }
    this.end = (this.end + 1) % this.max;
  }

  public last () : T | null
  {
    if (this.empty)
    {
      return null;
    }
    const lastIndex : number = (this.end - 1) % this.max;
    return this.buffer[lastIndex];
  }

  public size () : number
  {
    if (this.empty)
    {
      return 0;
    }
    return ((this.end > this.start)
      ? (this.end - this.start)
      : (this.max + this.end - this.start));
  }

  public list () : T[]
  {
    if (this.empty)
    {
      return [];
    }
    if (this.end > this.start)
    {
      return this.buffer.slice(this.start, this.end);
    }
    return this.buffer.slice(this.start).concat(
      this.buffer.slice(0, this.end));
  }

  public clear () : void
  {
    this.empty = true;
    this.start = 0;
    this.end = 0;
  }

  public [Symbol.iterator] () : Iterator<T>
  {
    // Just enclose a copy of the list and then use its iterator. Magic!!
    const list : T[] = this.list();
    return list[Symbol.iterator]();
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/support/utilities/ring-buffer.ts